import moment, { DurationInputArg2 } from "moment";

import { FILTER_NAMES, PLATFORMS, YYYY_MM_DD_HH_mm_ss } from "shared";

const getFilteredValues = (
    filterName: FILTER_NAMES,
    id: number,
    name: string
) => ({
    filterName,
    value: [{ id, name }]
});

const isFtPlatform = (platform: PLATFORMS) => platform === PLATFORMS.Ft;

const isUnknownPlatform = (platform: PLATFORMS) =>
    platform === PLATFORMS.Unknown;

const getDateAfterSomeTime = (
    dateInUtc: string,
    duration: number,
    unit: DurationInputArg2
) => {
    const dateMoment = moment.utc(dateInUtc, YYYY_MM_DD_HH_mm_ss);
    const plusTime = dateMoment.clone().add(duration, unit);

    return plusTime.toISOString();
};

export {
    getFilteredValues,
    isFtPlatform,
    isUnknownPlatform,
    getDateAfterSomeTime
};
